import { createGetEndpoint } from '@sonar-software/sonar-http';
import { RelatedCounts } from '@sonar-software/sonar-ts-types';

export type GetLatestImportCountsResponse = {
	importId: number;
	relatedCounts: RelatedCounts;
};

export const getLatestImportCounts = createGetEndpoint<void, GetLatestImportCountsResponse>(
	'/api/v3/core/imports/latest-counts'
);
